import { render, staticRenderFns } from "./ProfitPosition.vue?vue&type=template&id=06830bf6&scoped=true"
import script from "./ProfitPosition.vue?vue&type=script&lang=js"
export * from "./ProfitPosition.vue?vue&type=script&lang=js"
import style0 from "./ProfitPosition.vue?vue&type=style&index=0&id=06830bf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06830bf6",
  null
  
)

export default component.exports